import { Component, OnDestroy, OnInit } from '@angular/core';
import * as echarts from 'echarts/core';
import { StatsService } from '../../../../shared/services/pubServices/stats.service';
import { IpublisherStatFilter, IDropdownSettings, Iklocki, Page, PageClass, Ianalytics, IcountryOffers, Ianalyticsgrid} from '../../../../shared/filters/filters';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { LockerService } from 'src/app/shared/services/pubServices/lockers.service';
import { MapChart } from 'echarts/charts';

interface Ivisible{
  datemonthVisible?: boolean,
  groupbyVisible?: boolean,
  groupbyoffercountryVisible?: boolean,
  itemsdetailVisible?: boolean,
  selectVisible?: boolean,
  icoGrid?: boolean
}

@Component({
  selector: 'pub-stats-analytics',
  templateUrl: './analytics.html',
  styleUrls: ['./analytics.scss']
})


export class analyticsComponent implements OnInit, OnDestroy {
  option: any;
  optionWorld: any;
  optionPie: any;

  max: any;
  globeData: any;

  chart: any;
  pieChart: any;
  pieItemName: string;
  isChartTimeline: boolean;
  isChartPie: boolean;
  isChartGlobe: boolean;

  colorList = ['#c4861a', '#f6a821', '#936413', '#FF6018', '#8c8c8c', '#a8c2bb'];
  colorPieList = ['#df784c', '#a63100', '#ffb146', '#5d95c4', '#3979af', '#58c99c', '#32b782', '#d27a00', '#a66000', '#094e88'];

  dataVisitors: any;
  dataClicks: any;
  dataConversions: any;
  dataGrid: any;

  // selektor dropdown odpowiadające filtrowaniu
  SelectedDaterange?: number = 5; // domyślnie jest -> MTD
  SelectedDate12month?: number = 1;
  selectedDate12month?: boolean = false;
  selectedOffer?: boolean = false;
  SelectedGroupby?: number = 3;   // domyślnie jest -> country
  selectType?: number = 1;
  selectTypeName?: string;

  // przyciski przełączające widok chart/table
  activeView?: string;
  viewTable?: boolean;
  icoGridColor?: string;
  icoGlobeColor?: string;
  icoPieColor?: string;

  detailsData: any;
  detailsOfferCountry: any;

  // selector dropdown Country for Offer
  dropdownSelectedOfferCountry : any[] = [];
  dropdownSettingsOfferCountry : IDropdownSettings = {
    singleSelection: true,
    idField:  "id",
    textField: "name",
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
    allowSearchFilter: true
  };

  // selector dropdown Details
  dropdownSelectedDetails : any[] = [];
  dropdownSettingsDetails : IDropdownSettings = {
    singleSelection: true,
    idField:  "id",
    textField: "name",
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
    allowSearchFilter: true
  };

  klocki : Iklocki = {visitors:320, clicks:100, conversions:80, revenue:34.5, epc: 2.3, cr:0.2};

  request : Ianalytics = {dateRange:5, dateMonth:0, groupBy:3, groupByOfferCountry:0, itemDetails:"0"};
  requestGrid : Ianalyticsgrid = {pageSize:40, pageNumber:1, dateRange:5, dateMonth:0, groupBy:4, groupByOfferCountry:0, itemDetails:""};
  requestCountryOffers : IcountryOffers = {dateRange:3, dateMonth:0, groupByOfferCountry:0};

  visible : Ivisible = {
    datemonthVisible: false,
    groupbyVisible: true,
    groupbyoffercountryVisible: false,
    itemsdetailVisible: true,
    selectVisible: false,
    icoGrid: true
  };

  // grid definition
  page = new Page();
  offsetNumber: number;
  pageSizeDefinition = 40;
  filter : IpublisherStatFilter = { pageNumber:1, pageSize:1000 };
  ColumnMode = ColumnMode;

  pagelocker :  PageClass = {pageNumber:1, pageSize:250};

  // -----------------------------------------------

  constructor(private statsService: StatsService,
              private sharedServices: SharedService,
              private lockerService: LockerService ) {
    echarts.use([MapChart]);
    this.isChartTimeline = true;
    this.isChartPie = true;
    this.isChartGlobe = true;

    this.offsetNumber = 0;
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
   }

  ngOnInit() {
    // może być: timeline, world, pie, table
    this.activeView = "timeline";

    this.icoGlobeColor="txt-primary";
    this.icoPieColor="txt-primary";
    this.icoGridColor="txt-primary";

    this.viewTable = false;
    this.selectedOffer = false;

    this.selectType = 1;
    this.selectTypeName = "Visitors";

    this.SelectedGroupby = this.request.groupBy;

    this.readWorldMap(data => {
      echarts.registerMap('world', data);
    });

    this.getCountries("country");
    // API: rządanie danych All dla Device
    this.sendRequest(this.request);
  }

  ngOnDestroy(){
  }

  // ------------------------------------------------
  //zmiana Daterange podstawy czasu
  //this.SelectedDaterange:
  //  1 - Today
  //  2 - Yesterday
  //  3 - Last 7 days
  //  4 - Last 30 days
  //  5 - MTD
  //  6 - Month.. wybór miesiąca wstecz
  changeDaterangeSelect(event){

    this.request.dateRange = Number(this.SelectedDaterange);
    this.requestGrid.dateRange = Number(this.SelectedDaterange);

    if(this.request.dateRange == 6){
        // wchodzimy gdzy wybieramy - last month
        this.visible.datemonthVisible = true;
        const d = new Date();
        //d.getMonth() zwraca wartość od zera = January
        this.SelectedDate12month = d.getMonth();
        if(this.SelectedDate12month == 0)
        this.SelectedDate12month = 12;
        this.request.dateMonth = this.SelectedDate12month;
        this.requestGrid.dateMonth = this.SelectedDate12month;

        this.sendRequest(this.request);
        if(this.activeView == "timeline")
          this.setPage({ offset: 0 });

      }
    else
      {
        // wchodzimy dla wszystkich pozostałych
        this.visible.datemonthVisible = false;
        this.SelectedDate12month = 0;
        this.request.dateMonth = this.SelectedDate12month;
        this.requestGrid.dateMonth = this.SelectedDate12month;

        this.sendRequest(this.request);
        if(this.activeView == "timeline")
          this.setPage({ offset: 0 });
      }
  }

  //  wybór miesiąca wstecz
  changeDate12month(event){
    this.request.dateMonth = Number(this.SelectedDate12month);
    this.requestGrid.dateMonth = Number(this.SelectedDate12month);

    this.sendRequest(this.request);
    if(this.activeView == "timeline")
      this.setPage({ offset: 0 });
  }

  // ------------------------------------------------

  // wybór GroupBy
  //this.SelectedGroupby:
  //  1 - Offer
  //  2 - Locker
  //  3 - Country
  //  4 - Browser
  //  5 - OS
  //  6 - Device
  changeGroupbySelect(event){
    this.detailsData = [];
    this.dropdownSelectedDetails = [];
    this.dropdownSelectedOfferCountry = [];
    this.request.groupByOfferCountry = 0;
    this.request.itemDetails = "0";
    this.visible.groupbyoffercountryVisible = false;

    this.request.groupBy = Number(this.SelectedGroupby);
    this.requestGrid.groupBy = Number(this.SelectedGroupby);

    // załadowanie do Details odpowiednich wartości
    if(this.SelectedGroupby==1)
    {
      // załadowanie do this.dropdownSelectedDetails ofert ale dla specyficznego kraju wg. dropdownSelectedCountry
      this.visible.groupbyoffercountryVisible = true;
      this.getCountries("offer");
      //this.getOffer();
    }
    if(this.SelectedGroupby==2)
    {
      // załadowanie do this.dropdownSelectedDetails contentLockerów
      this.getLocker();
    }
    if(this.SelectedGroupby==3)
    {
      // załadowanie do this.dropdownSelectedDetails krajów
      this.getCountries("country");
    }
    if(this.SelectedGroupby==4)
    {
     // załadowanie do this.dropdownSelectedDetails listy przeglądarek, uprzednio je czytając
      this.getBrowser();
    }
    if(this.SelectedGroupby==5)
    {
      // załadowanie do this.dropdownSelectedDetails listy OS, uprzednio je czytając
      this.getOS();
    }
    if(this.SelectedGroupby==6)
    {
      // załadowanie do this.dropdownSelectedDetails listy Device, uprzednio je czytając
      this.getDevice();
    }

    // ------------------------------------------------

    this.sendRequest(this.request);
    if(this.SelectedGroupby!=1){
      this.setPage({ offset: 0 });
    }
    else
    {
      // jeżeli wchodzimy do Offer bez wskazywania na konkretny kraj
      this.page.totalElements = 0;
      this.page.totalPages = 0;
      this.page.pageNumber = 0;
      this.dataGrid = [];
    }

  }

  changeSelectType(event){
    this.request.selectType = Number(this.selectType);
    // 1 - Visitors, 2 - Clicks, 3 - Conversions, 4 - Revenue
    switch(Number(this.selectType)){
      case 1:
        this.selectTypeName = "Visitors";
        break;
      case 2:
        this.selectTypeName = "Clicks";
        break;
      case 3:
        this.selectTypeName = "Conversions";
        break;
      case 4:
        this.selectTypeName = "Revenue $";
        break;
      }

    this.sendRequest(this.request);
  }

  // ------------------------------------------------
  // wybór konkretnego parametry dla Details
  ondropdownSelectDetails(event){
    this.request.itemDetails = "0";

    // offer
    if(this.SelectedGroupby==1){
      this.request.itemDetails = String(this.dropdownSelectedDetails[0].offerId);
    }

    // locker
    if(this.SelectedGroupby==2){
      this.request.itemDetails = String(this.dropdownSelectedDetails[0].lockerId);
    }
    // country / Browser / OS / Device
    if(this.SelectedGroupby! >= 3){
      this.request.itemDetails = String(this.dropdownSelectedDetails[0].id);
    }

    this.sendRequest(this.request);
    if(this.activeView == "timeline"){
      this.requestGrid.itemDetails = this.request.itemDetails;
      this.setPage({ offset: 0 });
    }
  }

  ondropdownDeSelectDetails(event){
    this.request.itemDetails = "0";
    this.requestGrid.itemDetails = "0";

    this.sendRequest(this.request);
    this.setPage({ offset: 0 });
  }

  // ------------------------------------------------
  // wybór konkretnego country dla groupBy=Offer
  ondropdownSelectOfferCountry(event){

    this.requestCountryOffers.dateRange = Number(this.SelectedDaterange);
    this.requestCountryOffers.dateMonth = Number(this.SelectedDate12month);
    this.requestCountryOffers.groupByOfferCountry = this.dropdownSelectedOfferCountry[0].id;

    this.request.groupByOfferCountry = this.dropdownSelectedOfferCountry[0].id;
    this.requestGrid.groupByOfferCountry = this.dropdownSelectedOfferCountry[0].id;

    this.getCountryOffers(this.requestCountryOffers);

    this.sendRequest(this.request);
    if(this.activeView == "timeline")
      this.setPage({ offset: 0 });
  }

  ondropdownDeSelectOfferCountry(event){
    this.detailsData = [];
    this.request.itemDetails = "0";
    this.request.groupByOfferCountry = 0;
    this.requestGrid.groupByOfferCountry = 0;

    this.sendRequest(this.request);
    this.page.totalElements = 0;
    this.page.totalPages = 0;
    this.page.pageNumber = 0;
    this.dataGrid = [];
    this.setPage({ offset: 0 });
  }

  // ------------------------------------------------
  // wybór kolejnych widoków
  onGridIco(){
    if(this.viewTable)
    {
      this.icoGridColor = "txt-primary";
      this.viewTable = false;
    }
    else
    {
      this.icoGridColor = "txt-success";
      this.viewTable = true;      
      this.requestGrid.groupBy = Number(this.SelectedGroupby);
      this.setPage({ offset: 0 });
    }
  }

  onGlobeIco(){
    if(this.activeView=="timeline")
    {
      // jestem w "timeline" i wchodzę do globe
      this.icoGlobeColor = "txt-success";
      this.activeView="globe";
      this.visible.groupbyVisible = false;
      if(this.SelectedGroupby == 1){ //jeżeli groupBy jest Offer
        this.SelectedGroupby = 2; //default = Locker
        this.request.groupBy = 2;
        this.visible.groupbyoffercountryVisible=false;
        this.dropdownSelectedDetails = [];       
        this.getLocker();
      }
      
      this.visible.selectVisible = true;
      this.visible.icoGrid = false;
      this.viewTable = false;

      if(this.SelectedGroupby == 3)
      {
        this.SelectedGroupby = 2; // locker
        this.request.groupBy = 2;
        this.getLocker();
        this.selectType = 4;
        this.selectTypeName = "Revenue $";
        this.request.selectType = 4;
      }
      else
        this.request.selectType = Number(this.selectType);
    }
      else
      {
        if(this.activeView=="pie"){
          // jestem w "pie" i wchodzę w globe
          this.icoGlobeColor = "txt-success";
          this.icoPieColor = "txt-primary";
          this.activeView="globe";
          this.visible.itemsdetailVisible = true;
          if(this.SelectedGroupby == 1){ //jeżeli groupBy jest Offer
            this.SelectedGroupby = 2; //default = Locker
            this.request.groupBy = 2;
            this.visible.groupbyoffercountryVisible=false;
            this.dropdownSelectedDetails = [];    
            this.getLocker();
          }
          this.visible.groupbyVisible = false;
          this.visible.selectVisible = true;
          this.visible.icoGrid = false;
          this.viewTable = false;
          this.request.selectType = Number(this.selectType);
        }
        else
        {
          // jestem w "globe" i wychodzę do timeline
          this.icoGlobeColor = "txt-primary";
          this.activeView="timeline";
          this.visible.itemsdetailVisible = true;
          this.visible.groupbyVisible = true;
          this.visible.selectVisible = false;
          this.visible.icoGrid = true;
          if(this.icoGridColor == "txt-success")
            this.viewTable = true;
          else
            this.viewTable = false;
        }
      }

    this.sendRequest(this.request);
  }

  onPieIco(){
    if(this.activeView=="timeline")
      {
        this.activeView="pie";
        this.icoPieColor = "txt-success";
        this.visible.itemsdetailVisible = false;
        this.visible.selectVisible = false;
        this.visible.icoGrid = false;
        this.viewTable = false;
      }
    else
      {
        if(this.activeView=="globe"){
          this.icoGlobeColor = "txt-primary";
          this.icoPieColor = "txt-success";
          this.visible.itemsdetailVisible = false;
          this.visible.selectVisible = false;
          this.visible.groupbyVisible = true; // fix do 2.10.1
          this.visible.icoGrid = false;
          this.viewTable = false;
          this.activeView="pie";
        }
        else
        {
          this.icoPieColor = "txt-primary";
          this.activeView="timeline";
          this.visible.itemsdetailVisible = true;
          this.visible.icoGrid = true;
          if(this.icoGridColor == "txt-success")
            this.viewTable = true;
          else
            this.viewTable = false;

        }
      }

    this.sendRequest(this.request);
  }

  // ------------------------------------------------
  // łądowanie danych

  getPie(){

    this.readTestDataPie(data => {
      // this.detailsData = data.data;
      this.pieChart = data.data.pie;
      this.chartpieOption();

      this.klocki.clicks = data.data.cards.clicks;
      this.klocki.conversions = data.data.cards.conversions;
      this.klocki.visitors = data.data.cards.visitors;
      this.klocki.revenue = data.data.cards.revenue;
      this.klocki.epc = (this.klocki.conversions! * this.klocki.revenue!)/this.klocki.clicks!; //data.data.cards.epc;
      this.klocki.cr = this.klocki.conversions! / this.klocki.clicks!;// data.data.cards.cr;

    });
  }

  readTestData(cb){
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/pub-stats/testdata.json`);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  readTestDataPie(cb){
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/pub-stats/piedata.json`);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  setPage(pageInfo){
    this.requestGrid.pageNumber = pageInfo.offset+1;
    this.requestGrid.pageSize = this.pageSizeDefinition;

    console.log("GRID: ", this.requestGrid);
    this.statsService.getAnalyticsGrid(this.requestGrid)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;

      console.log("RAW: ", data);
      console.log("PAGE: ", this.page);
      this.dataGrid = data.data;
      console.log("DATA: ", this.dataGrid);
     },
     error => {
       console.log(error);
     });
  }

  setGlobeview(){

    this.statsService.getLiveVisitors()
    .subscribe(
     data => {
      this.globeData = data.data;
      this.max = Math.max.apply(Math, this.globeData.map(function(o) { return o.value; }));
      this.chartGlobeOption();
     },
     error => {
       console.log(error);
     });

  }

  // ------------------------------------------------

  readWorldMap(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/world.json`);
    req.onload = () => {
      cb(req.response);
    };
    req.send();
  }

  sendRequest(data: any){
    console.log("Send Request: ", this.request);

    if(this.activeView == "timeline"){
      this.statsService.getAnalytics(data)
      .subscribe(
      data => {
        this.klocki.visitors = data.data.cards.visitors;
        this.klocki.clicks = data.data.cards.clicks;
        this.klocki.conversions = data.data.cards.conversions;
        this.klocki.revenue = data.data.cards.revenue;
        this.klocki.epc = data.data.cards.epc;
        this.klocki.cr = data.data.cards.cr;

        this.chart = data.data.chart;

        if(this.chart.date.length === 0 )
          this.isChartTimeline = false;
        else
        {
          this.isChartTimeline = true;
          this.chartTimelineOption();
        }
      },
      error => {
        console.log(error);
      });
    }

    if(this.activeView == "pie"){
      this.statsService.getAnalyticsPie(data)
      .subscribe(
      data => {
        this.klocki.visitors = data.data.cards.visitors;
        this.klocki.clicks = data.data.cards.clicks;
        this.klocki.conversions = data.data.cards.conversions;
        this.klocki.revenue = data.data.cards.revenue;
        this.klocki.epc = data.data.cards.epc;
        this.klocki.cr = data.data.cards.cr;

        this.pieChart = data.data.pie;

        if(this.pieChart.length === 1 )
          this.isChartPie = false;
        else
        {
          this.isChartPie = true;
          this.pieItemName = this.pieChart[0][0];
          this.chartpieOption();
        }

      },
      error => {
        console.log(error);
      });
    }

    if(this.activeView == "globe"){
      this.statsService.getAnalyticsGlobe(data)
      .subscribe(
      data => {
        this.klocki.visitors = data.data.cards.visitors;
        this.klocki.clicks = data.data.cards.clicks;
        this.klocki.conversions = data.data.cards.conversions;
        this.klocki.revenue = data.data.cards.revenue;
        this.klocki.epc = data.data.cards.epc;
        this.klocki.cr = data.data.cards.cr;

        this.globeData = data.data.worldwideData;

        if(this.globeData.length!=0)
        {
          this.isChartGlobe = true;
          this.max = Math.max.apply(Math, this.globeData.map(function(o) { return o.value; }));
          this.chartGlobeOption();
        }
        else
          this.isChartGlobe = false;
        //
      },
      error => {
        console.log(error);
      });
    }
  }

  // ------------------------------------------------
  // załadowanie do this.dropdownSelectedDetails odpowiednich danych wynikających z parametry SelectedGroupby
  getCountryOffers(requestOffer: any){
    this.dropdownSettingsDetails = {
      singleSelection: true,
      idField:  "offerId",
      textField: "offerName",
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
      allowSearchFilter: true
    };

    this.statsService.getAnalyticsCountryOffers(requestOffer)
       .subscribe(
        data => {
          this.detailsData = data.data;
      },
      error => {
        console.log(error);
      });

  }

  getLocker(){

    this.dropdownSettingsDetails = {
      singleSelection: true,
      idField:  "lockerId",
      textField: "lockerName",
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
      allowSearchFilter: true
    };

    this.lockerService.getAllContentLocker(this.pagelocker)
    .subscribe(
     data => {
      // this.page.totalElements = data.totalRecords;
      // this.page.totalPages = data.totalPages;
      // this.page.pageNumber = data.pageNumber-1;
      // this.page.size = data.pageSize;

      this.detailsData = data.data;
       },
     error => {
       console.log(error);
     });
  }

  getCountries(groupby : string) {

    if(groupby == "country"){
      this.dropdownSettingsDetails = {
        singleSelection: true,
        idField:  "id",
        textField: "name",
        itemsShowLimit: 1,
        closeDropDownOnSelection: true,
        allowSearchFilter: true
      };
    }

    if(groupby == "offer"){
    this.dropdownSettingsOfferCountry = {
      singleSelection: true,
      idField:  "id",
      textField: "name",
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
      allowSearchFilter: true
    }};

    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
      if(groupby == "country"){
       this.detailsData = data.data.countries;
      }
      if(groupby == "offer"){
        this.detailsOfferCountry = data.data.countries;
      }
     },
     error => {
       console.log(error);
     });
  }

  getBrowser(){
    this.dropdownSettingsDetails = {
      singleSelection: true,
      idField:  "id",
      textField: "name",
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
      allowSearchFilter: true
    };

    this.readBrowser(data => {
      this.detailsData = data.data;
    });
  }

  getOS(){
    this.dropdownSettingsDetails = {
      singleSelection: true,
      idField:  "id",
      textField: "name",
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
      allowSearchFilter: true
    };

    this.readOS(data => {
      this.detailsData = data.data;
    });
  }

  getDevice(){
    this.dropdownSettingsDetails = {
      singleSelection: true,
      idField:  "id",
      textField: "name",
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
      allowSearchFilter: true
    };

    this.readDevice(data => {
      this.detailsData = data.data;
    });
  }

  readDevice(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/pub-stats/device.json`);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  readBrowser(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/pub-stats/browser.json`);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  readOS(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/pub-stats/os.json`);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  // ------------------------------------------------
  // obsługa poszczególnych widoków, ustawienie wykresów chart
  chartTimelineOption(){
    this.option = {
      color: this.colorList,
      legend: {
        // top: 60
      },
      tooltip: {
        trigger: 'axis',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#333',
        backgroundColor: 'rgba(255,255,255,0.9)',
        axisPointer: {
          label:  {
            formatter: function(params) {
              return echarts.format.formatTime('dd/MM/yyyy', params.value);
            }
         }}
      },
      xAxis: {
        type: 'category',
        // type: 'time',
        order: 'valueDesc',
        axisLabel: {
            formatter: function (value) {
                return echarts.format.formatTime('dd/MM/yyyy', value);
                // return echarts.time.format(value);
            }
        },
        data: this.chart.date
      },
      yAxis: {
        type: 'log',
        min: 0.1,
        minorSplitLine: {
          show: true
        }
      },
      series: [
        {
          name: 'Clicks',
          type: 'line',
          lineStyle: {
            color: '#c4861a',
            width: 2
          },
          data: this.chart.clicks
        },
        {
          name: 'Visitors',
          type: 'line',
          lineStyle: {
            color: '#f6a821',
            width: 2
          },
          data: this.chart.visitors
        },
        {
          name: 'Conversions',
          type: 'line',
          lineStyle: {
            color: '#936413',
            width: 5
          },
          markLine: {
            lineStyle: {
              color: '#936413',
            },
            data: [{ type: 'average', name: 'Avg' }]
          },
          data: this.chart.conversions
        },
        {
          name: 'Revenue',
          type: 'line',
          tooltip: {
            valueFormatter: value => value.toFixed(2) + '$ '
          },
          lineStyle: {
            color: '#FF6018',
            width: 3
          },
          markLine: {
            lineStyle: {
              color: '#FF6018',
            },
            data: [{ type: 'average', name: 'Avg' }]
          },
          data: this.chart.revenue
        },
        {
          name: 'EPC',
          type: 'line',
          tooltip: {
            valueFormatter: value => value.toFixed(3) + ' $'
          },
          lineStyle: {
            color: '#8c8c8c',
            width: 2
          },
          data: this.chart.epc
        }
        // {
        //   name: 'CR',
        //   type: 'line',
        //   tooltip: {
        //     valueFormatter: value => value.toFixed(3) + ' $'
        //   },
        //   lineStyle: {
        //     color: '#a8c2bb',
        //     width: 2
        //   },
        //   data: this.chart.cr
        // }
      ]
    }
  }

  chartpieOption(){
    this.optionPie = {
      color: this.colorPieList,
      legend: {
        orient: 'vertical',
        left: 'left',
      },
      tooltip: {},
      title: [
        {
          text: 'Revenue',
          left: '40%',
          textAlign: 'center',
          textStyle:{
            color: '#FF6018'
          }
        },
        {
          text: 'Conversions',
          left: '80%',
          textAlign: 'center',
          textStyle:{
            color: '#936413'
          }
        },
        {
          text: 'Visitors',
          left: '40%',
          top: '50%',
          textAlign: 'center',
          textStyle:{
            color: '#f6a821'
          }
        },
        {
          text: 'Clicks',
          left: '80%',
          top: '50%',
          textAlign: 'center',
          textStyle:{
            color: '#c4861a'
          }
        }
      ],
      dataset: {
        source: this.pieChart
      },
      series: [
        {
          title: {
            text: 'Revenue',
            left: 'center'
          },
          name: 'Revenue',
          type: 'pie',
          radius: '20%',
          center: ['40%', '30%'],
          encode: {
            itemName: this.pieItemName,
            value: 'revenue'
          },
          tooltip: {
            valueFormatter: value => value.toFixed(2) + ' $'
          }
          // No encode specified, by default, it is '2012'.
        },
        {
          name: 'Conversions',
          type: 'pie',
          radius: '20%',
          center: ['80%', '30%'],
          encode: {
            itemName: this.pieItemName,
            value: 'conversions'
          }
        },
        {
          name: 'Visitors',
          type: 'pie',
          radius: '20%',
          center: ['40%', '75%'],
          encode: {
            itemName: this.pieItemName,
            value: 'visitors'
          }
        },
        {
          name: 'Clicks',
          type: 'pie',
          radius: '20%',
          center: ['80%', '75%'],
          encode: {
            itemName: this.pieItemName,
            value: 'clicks'
          }
        }
      ]
    };

  }

  chartGlobeOption(){
    this.optionWorld = {
      // title: {
      //   text: 'World',
      //   textStyle:{
      //     width: 300,
      //     overflow: 'break'
      //   },
      //   left: 'center'
      // },
      tooltip: {
        trigger: 'item',
        showDelay: 0,
        transitionDuration: 0.2,
        valueFormatter: value => value.toFixed(2)
      },
      visualMap: {
        left: 'right',
        min: 1,
        max: this.max,
        inRange: {
          color: [
            '#313695',
            '#4575b4',
            '#74add1',
            '#abd9e9',
            '#e0f3f8',
            '#ffffbf',
            '#fee090',
            '#fdae61',
            '#f46d43',
            '#d73027',
            '#a50026'
          ]
        },
        text: ['High', 'Low'],
        calculable: true
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'top',
        feature: {
          saveAsImage: {},
          restore: {}
        }
      },
      series: [
        {
          name: this.selectTypeName,
          type: 'map',
          roam: true,
          map: 'world',
          label: {
            show: true,
            color: 'inherit',
            fontWeight: 'normal',
            formatter: function (param: any) {
              var ilosc = param.value;
              if(ilosc > 0)
                {return param.value.toFixed(2)}
              else
                return '';
              }
          },
          emphasis: {
            label: {
              show: true
            }
          },
          data: this.globeData
        }
      ]
    };
  }

}
